module.exports = __webpack_public_path__ + "static/img/scene.fc9cad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene.png
// module id = w+Zb
// module chunks = 4